import { useSyncExternalStore } from "react";

const KEY = "portal_lang";
const listeners = new Set();
export function getLang() { return localStorage.getItem(KEY) || "it"; }
export function setLang(l) { localStorage.setItem(KEY, l); listeners.forEach((fn) => fn()); }
function subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); }

// Dizionario IT -> EN. La chiave è la stringa italiana usata nell'UI del portale.
// Se manca una traduzione, viene mostrato il testo italiano originale.
const EN = {
  // Navigazione / chrome
  "Home": "Home",
  "Riepilogo": "Overview",
  "Contratti": "Contracts",
  "Contatori": "Meters",
  "Preventivi": "Quotes",
  "Monte ore": "Support hours",
  "Dispositivi": "Devices",
  "Documentazione": "Documents",
  "Report": "Reports",
  "Ticket": "Tickets",
  "Lavorazioni": "Repairs",
  "Esci": "Log out",
  "Area cliente": "Client area",
  "Lingua": "Language",
  // Titoli / sottotitoli pagine (component H)
  "I tuoi contratti": "Your contracts",
  "Anteprima dei documenti contrattuali e servizi attivi": "Preview of contract documents and active services",
  "Servizi attivi": "Active services",
  "Anagrafica": "Company details",
  "Contratti attivi": "Active contracts",
  "Documentazione condivisa": "Shared documents",
  "Documenti condivisi con te e file che carichi tu": "Documents shared with you and files you upload",
  "Le tue riparazioni": "Your repairs",
  "Stato dei tuoi dispositivi in riparazione e report": "Status of your devices under repair and reports",
  "Monte ore assistenza": "Support hours",
  "Estratto conto delle ore acquistate e utilizzate": "Statement of purchased and used hours",
  "Estratto conto": "Statement",
  "Contatori dispositivi": "Device meters",
  "Letture e consumi dei tuoi dispositivi": "Readings and usage of your devices",
  "Report di consumo": "Usage reports",
  "Riepiloghi periodici dei tuoi servizi": "Periodic summaries of your services",
  "I miei ticket": "My tickets",
  "Apri richieste di assistenza e segui le risposte del nostro team": "Open support requests and follow our team's replies",
  "Consulta e accetta i preventivi che ti abbiamo condiviso": "Review and accept the quotes we shared with you",
  "Stato": "Status",
  "Oggetto *": "Subject *",
  "Ticket inviato": "Ticket submitted",
  "Fotocopiatrici": "Copiers",
  "Dispositivi": "Devices",
  // ISO 27001
  "Sicurezza ISO 27001": "ISO 27001 security",
  "Dichiarazione di Applicabilità (Annex A) dei controlli di sicurezza": "Statement of Applicability (Annex A) of security controls",
  "La Dichiarazione di Applicabilità non è ancora disponibile.": "The Statement of Applicability is not available yet.",
  "Conformità": "Compliance",
  "Applicabili": "Applicable",
  "Attuati": "Implemented",
  "In corso": "In progress",
  "Non avviati": "Not started",
  "Scarica PDF": "Download PDF",
  "Controllo": "Control",
  "Titolo": "Title",
  "Applicabile": "Applicable",
  "Sì": "Yes",
  "Escluso": "Excluded",
  "Non avviato": "Not started",
  "Attuato": "Implemented",
};

export function useLang() {
  return useSyncExternalStore(subscribe, getLang, getLang);
}

// Traduttore "per stringa sorgente": t("Contratti") -> "Contracts" se EN, altrimenti IT.
export function translate(text, lang) {
  if (!text || lang !== "en") return text;
  return EN[text] || text;
}
